import Route from '@ember/routing/route';

export default class CommunityRoute extends Route {}
